import React from "react";
import { Link } from "react-router-dom";

interface FooterProps {
  footerClass?: string;
}

const ClickHandler = (): void => {
  window.scrollTo(10, 0);
};

const Footer: React.FC<FooterProps> = ({ footerClass }) => {
  return (
    <footer className={`wpo-site-footer ${footerClass || ""}`}>
      <div className="container">
        {/* Upper Footer */}
        <div className="wpo-upper-footer">
          <div className="row">
            {/* Left Text Section */}
            <div className="col col-lg-7 col-md-6 col-sm-12 col-12">
              <div className="footer-title-left">
                <h2>
                  No podemos esperar a ver a todos nuestros queridos amigos y familiares
                  en nuestra boda. ¡Su presencia hará que nuestro día sea verdaderamente especial!
                </h2>
              </div>
            </div>

            {/* Links Section */}
            <div className="col col-lg-2 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Inicio</h3>
                </div>
                <ul>
                  <li>
                    <Link onClick={ClickHandler} to="/home">
                      Inicio
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/story">
                      Nuestra Historia
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/gallery">
                      Galería
                    </Link>
                  </li>
                  <li>
                    <Link onClick={ClickHandler} to="/invitation">
                      Invitación
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contacts Section */}
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  {/* <h3>Contactos</h3> */}
                </div>
                <ul>
                  {/* <li>TBC</li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Lower Footer */}
        <div className="wpo-lower-footer">
          <div className="row g-0">
            <div className="col col-lg-6 col-12">
              <p className="copyright">
                Copyright © <span>2025 </span> |{" "}
                <Link onClick={ClickHandler} to="/home">
                  V & R Wedding
                </Link>{" "}
                | All Rights Reserved
              </p>
            </div>

            {/* <div className="col col-lg-6 col-12">
              <ul className="links">
                <li>
                  <Link onClick={ClickHandler} to="/">
                    <i className="ti-facebook" aria-label="Facebook"></i>
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/">
                    <i className="ti-twitter-alt" aria-label="Twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link onClick={ClickHandler} to="/">
                    <i className="ti-instagram" aria-label="Instagram"></i>
                  </Link>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
